<template>
  <div v-if="!loading" class="history-items text-left">
    <PageModal
      v-model:isOpen="isPageModalOpen"
      :headerModel="{
        title: operationTypeTitles[selectedItemDetails?.operation_type],
        shadowed: true,
      }"
      duration="100"
    >
      <template v-if="!$isAndroid" #head>
        <span class="text-red">{{ $t`Закрыть` }}</span>
      </template>
      <ItemDetails :details="selectedItemDetails" />
    </PageModal>
    <template v-if="items && items.length">
      <div
        v-for="(item, i) in items"
        :key="item.transaction_id"
        class="history-item"
      >
        <div
          v-if="isDateVisible(items[i - 1], item)"
          class="history-item__date text-grey text-size-xs text-left"
        >
          {{ $getFormattedDate(item.transaction_date, "DD MMMM YYYY") }}
        </div>
        <PaymentCard :data="item" @click="showDetails(item)" />
      </div>
    </template>
    <div v-else class="history-items--empty">
      <div class="img-wrapper">
        <img src="@/assets/images/no_purchases.png" />
      </div>
      <div
        class="no-history-text"
        v-html="$t`За выбранный период <br />ни одной покупки не найдено.`"
      ></div>
    </div>
  </div>
  <div v-else class="history-items__skeletons">
    <SkeletonLoader type="avatar-5" />
  </div>
</template>

<script>
import ItemDetails from "@/components/dashboard/history/RedHistoryItemDetails.vue";
import PaymentCard from "@/components/dashboard/history/PaymentCard.vue";
import SkeletonLoader from "@/components/shared/loaders/SkeletonLoader.vue";
import PageModal from "@/components/shared/modal/PageModal.vue";

export default {
  name: "RedHistoryItems",
  components: {
    PageModal,
    PaymentCard,
    ItemDetails,
    SkeletonLoader,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isPageModalOpen: false,
      selectedItemDetails: null,
    };
  },
  computed: {
    operationTypeTitles() {
      return {
        SHOP_OPER: this.$t`Покупки`,
        OPER: this.$t`Покупки`,
        PAY_INVOICE: this.$t`Оплата счета`,
        PREPAYMENT: this.$t`Досрочное погашение`,
        TRANSFER: this.$t`Перевод остатка`,
      };
    },
  },
  methods: {
    showDetails(details) {
      this.$logAnalyticEvent("mybank_red_purchases_show_check");
      this.selectedItemDetails = details;
      this.isPageModalOpen = true;
    },
    isDateVisible(item1, item2) {
      if (!item1 || !item2) {
        return true;
      }
      return (
        item1.transaction_date.substring(0, 10) !==
        item2.transaction_date.substring(0, 10)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

$logo-diameter: 38px;

.icon {
  height: 100%;
}

.history-items {
  &__skeletons {
    margin-top: 31px;
  }

  .history-item {
    margin-bottom: 1px;

    &__date {
      padding: 10px 0 7px 13px;
    }
  }

  &--empty {
    padding: 40px 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .img-wrapper {
      width: 120px;
      height: 120px;
      margin-bottom: 30px;

      & > img {
        width: 100%;
        height: 100%;
      }
    }

    .no-history-text {
      font-size: 15px;
      line-height: 19px;
      text-align: center;
      color: #a8a8a8;
    }
  }
}
</style>
